export const services = {
  headers: {
    requestedService: "الخدمة المطلوبة",
  },
  actions: {
    discardRequest: "تجاهل الطلب",
  },
  storeInactiveTitle: "متجر الخدمات غير مفعّل",
  storeInactiveDesc1:
    "لتلقّي طلبات التجارب والخدمات الإضافية، عليك تفعيل متجرك.",
  storeInactiveDesc2:
    "بمجرد التفعيل، يمكن لنزلائك طلب الخدمات مباشرةً من WhatsApp.",
  activateStoreBtn: "تفعيل متجر الخدمات",

  noServicesDesc1:
    "فعِّل التجارب من خلال إعداد خدماتك الإضافية: الإفطار أو الجولات أو خدمات النقل، أو أيًّا كان ما تقدّمه.",
  noServicesDesc2:
    "سيراها نزلاؤك مباشرةً بعد تسجيل الوصول، في WhatsApp مباشرةً.",
  addFirstServiceBtn: "إضافة أول تجربة أو خدمة لي",
};
